// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';

import I18n from '../../i18n/I18n';

// -- views
import Calendar from '../Calendar';

export default class DateField extends Component {

  static DEFAULT_DATE_FORMAT = 'dddd DD MMMM YYYY';

  static defaultProps = {
    readOnly: false,

    dateFormat: DateField.DEFAULT_DATE_FORMAT,

    date: new moment(),
    maxDate: null,
    minDate: null
  };

  static propTypes = {
    // param: moment date
    onChange: PropTypes.func.isRequired,

    readOnly: PropTypes.bool,

    dateFormat: PropTypes.string,

    date: PropTypes.object.isRequired,
    maxDate: PropTypes.object, // moment object
    minDate: PropTypes.object, // moment object
  };

  state = {
    displayCalendar: false
  };

  onToggle = () => {
    this.setState({
      displayCalendar: !this.state.displayCalendar
    });
  };

  onChange = (date) => {
    this.props.onChange(date);
    this.onToggle();
  };

  render() {
    const dateTimeFieldValue = this.props.date.locale(I18n.getCurrentLanguageWithoutRegionCode()).format(this.props.dateFormat);

    return (
      <div
        className="date_field input-group"
      >
        <div
          className="form-control"
          onClick={this.onToggle}
        >
          {dateTimeFieldValue}
        </div>

        <div
          className="input-group-addon"
          onClick={this.onToggle}
        >
          <i className="fa fa-calendar" />
        </div>

        {this.state.displayCalendar &&
          <Calendar
            minDate={this.props.minDate}
            maxDate={this.props.maxDate}
            inline
            readOnly={this.props.readOnly}
            onChange={this.onChange}
            defaultDate={this.props.date}
          />
        }
      </div>
    );
  }

}
